import CONSTANTS from '../constants';

export default class PaymentHelper {
  static isNotPaid(paymentStatus) {
    return (
      paymentStatus && paymentStatus.key === CONSTANTS.ORDERS.VARIABLES.PAYMENT_STATUSES.NOT_PAID
    );
  }
}
